import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { from, map } from 'rxjs';


@Injectable({ providedIn: 'root' })

export class AlertService {

    constructor(
        public toastr: ToastrService,
        public translate: TranslateService,
    ) {}

    triggerAlert(msg, type) { 

        if(msg == ""){
            return;
        }

        //This alert being displayed is custom toast alert, it is added in app.config.ts as CustomToastComponent
        this.toastr.show(
            this.getMessage(msg), type, {
                positionClass : "toast-bottom-right",
                enableHtml: true
                //   timeOut: 600000
            }
        );
    }

    getMessage(error){
        return error; //This will be translated later on
    }
   
}

